var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.948,
    height: 74.932,
    viewBox: "0 0 64.948 74.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_airplane_2268287_000000",
    d: "M43.474,5a8.368,8.368,0,0,0-8.327,8.327V28.4L12.406,39.377A2.5,2.5,0,0,0,11,41.645v9.992a2.5,2.5,0,0,0,3.149,2.394L35.98,48.2V63.814l-5.8,5.074a2.5,2.5,0,0,0-.859,1.9v6.661a2.5,2.5,0,0,0,3.174,2.394l10.981-3.148,10.981,3.148a2.5,2.5,0,0,0,3.174-2.394V70.787a2.5,2.5,0,0,0-.859-1.9l-5.8-5.074V48.2L72.8,54.03a2.5,2.5,0,0,0,3.149-2.394V41.645a2.5,2.5,0,0,0-1.405-2.264L51.8,28.4V13.334a8.368,8.368,0,0,0-8.327-8.327Zm0,5A3.347,3.347,0,0,1,46.8,13.33V29.983a2.5,2.5,0,0,0,1.405,2.238L70.951,43.2v5.178L49.119,42.554a2.5,2.5,0,0,0-3.149,2.42V64.958a2.5,2.5,0,0,0,.859,1.873l5.8,5.074v2.212L44.149,71.7a2.453,2.453,0,0,0-1.353,0l-8.483,2.42V71.905l5.8-5.074a2.5,2.5,0,0,0,.859-1.873V44.974a2.5,2.5,0,0,0-3.149-2.42L15.994,48.383V43.2L38.736,32.224a2.5,2.5,0,0,0,1.405-2.238V13.333A3.347,3.347,0,0,1,43.471,10Z",
    transform: "translate(-11 -5.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTPlan);
export default __webpack_public_path__ + "static/media/t_plan.3817e9d595bf11c7b835d524c5821523.svg";
export { ForwardRef as ReactComponent };